import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ y: 40, opacity: 0, filter: "blur(4px)" }}
    whileInView={{ y: 0, opacity: 1, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: "easeOut", delay }}
  >
    {children}
  </motion.div>
);

export const KineticLines = ({ lines, className = "", lineClassName = "", baseDelay = 0.2 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden">
        <motion.div
          className={lineClassName}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: [0.19, 1.0, 0.22, 1.0], delay: baseDelay + i * 0.15 }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

export const PerspectiveLines = ({ lines, className = "", lineClassName = "", baseDelay = 0.2 }) => (
  <div className={className} style={{ perspective: "1200px" }}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden" style={{ perspective: "1200px" }}>
        <motion.div
          className={lineClassName}
          style={{ transformOrigin: "50% 100%", transformStyle: "preserve-3d" }}
          initial={{ y: "110%", rotateX: -75, opacity: 0 }}
          animate={{ y: "0%", rotateX: 0, opacity: 1 }}
          transition={{ duration: 1.2, ease: [0.19, 1.0, 0.22, 1.0], delay: baseDelay + i * 0.16 }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);
